import type { CreateClientConfig } from '../generated/client.gen.js';

import { resolveApiBaseUrl } from './resolveApiBaseUrl.js';

/**
 * Точка настройки сгенерированного клиента: базовый URL, заголовки, в будущем -
 * токен авторизации и ретраи. Правим этот файл, а не код под src/generated.
 */
export const createClientConfig: CreateClientConfig = (config) => ({
  ...config,
  baseUrl: resolveApiBaseUrl(),
});
